import React from 'react'
import { Dialog, Button, Typography, makeStyles, Paper, Container, CircularProgress, Backdrop } from '@material-ui/core'
import { useDispatch, useSelector } from 'react-redux'
import { clearGatewayError, RootState } from 'src/lib/store'
import { genModalBody } from 'src/lib/helpers'
import { genPdf } from 'src/lib/pdf'
import { useHistory } from 'react-router-dom'

interface ConfirmationModalProps {
  dialogOpen: boolean
  setDialogOpen: (targetState: boolean) => void
}

export const ConfirmationModal: React.FC<ConfirmationModalProps> = ({ dialogOpen, setDialogOpen }) => {
  const { gateway, payload } = useSelector((state: RootState) => state)

  const { body } = genModalBody(payload.data)

  const classes = useStyles()
  const history = useHistory()
  const dispatch = useDispatch()

  if (gateway.submitting) {
    return (
      <Backdrop style={{ color: '#fff', zIndex: 100 }} open={true}>
        <CircularProgress color="inherit" />
      </Backdrop>
    )
  }

  const handleClose = () => {
    window.location.replace('https://www.safecu.org')
    setDialogOpen(false)
  }

  const handleTryAgain = () => {
    /* make sure that gateway error is cleared */
    dispatch(clearGatewayError())
    history.goBack()
  }

  return (
    <Dialog open={dialogOpen}>
      <Paper className="p-4">
        <Typography variant="h5" color="primary" className="mb-4">
          Thank you for submitting your request
        </Typography>
        <Typography variant="body1">
          {gateway.error &&
            <span data-cy="dialog">Your request could not be completed at this time. Please <a href="https://www.safecu.org/contact-us">contact us</a> at (916) 979-7233 or (800) SEE-SAFE, via live Chat, or Secure Messaging.</span>
          }

          {!gateway.error && !gateway.submitting &&
            <span data-cy="dialog">{body}</span>
          }
        </Typography>

        {!gateway.submitting && !gateway.error && (
          <Typography variant="body2" color="primary" className="mb-4 text-right">
            For a printable version of this response,{' '}
            <span className={classes.link} onClick={() => genPdf(payload.data)}>
              click here
            </span>
          </Typography>
        )}
        <Container className={classes.buttonContainer}>
          {gateway.error &&
            <Button className={classes.marginR} variant="contained" color="primary" onClick={handleTryAgain}>
              Try Again
            </Button>
          }
          <Button variant="contained" color="primary" onClick={handleClose}>
            Close
          </Button>
        </Container>
      </Paper>
    </Dialog>
  )
}

const useStyles = makeStyles({
  marginR: {
    marginRight: 10
  },
  link: {
    fontWeight: 'bold',
    '&:hover': {
      fontWeight: 'bold',
      cursor: 'pointer'
    }
  },
  buttonContainer: {
    marginTop: 40,
    display: 'flex',
    justifyContent: 'flex-end'
  },
  closeText: {
    color: 'white',
    '&:hover': {
      textDecoration: 'none'
    }
  }
})
